import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ planzone, filter }) =>
    present(
      repository
        .getCalendar(planzone, filter)
        .then((calendar) => ({ planzone, filter, calendar }))
        .catch((error) => Promise.reject({ planzone, filter })),
    );
}

export type { Interactor };

export { createInteractor };
